import React, { Suspense } from "react";
import { useEffect } from "react";
import HomeIntro from "../components/HomeIntro";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader";
import axios from "axios";
import { env } from "../config";
import * as Actions from "../redux/actions";
import bluemesh from "../assets/Bluemesh_background.png";
import ncs from "../assets/NCS_background.png";
import { Link } from "react-router-dom";

const InnovativeSlider = React.lazy(
  () => import("../components/InnovativeSliderHome")
);
const ServicesHome = React.lazy(() => import("../components/ServicesHome"));
const HomePageExpertiseDomainSection = React.lazy(
  () => import("../components/HomePageExpertiseDomainSection")
);
const Brouchure = React.lazy(() => import("../components/BrouchureHome"));
const History = React.lazy(() => import("../components/HistoryHome"));
const AgroTechConnectSection = React.lazy(
  () => import("../components/AgroTechConnectSection")
);
const Countries = React.lazy(() => import("../components/CountriesHome"));
const Footer = React.lazy(() => import("../components/Footer"));

function Home() {
  const dispatch = useDispatch();
  const HomeData: any = useSelector(
    (state: any) => state?.Page?.HomePageContent
  );
  const getHomePageData = () => {
    axios.get(`${env}/api/home-page-content?populate=deep`).then((res) => {
      dispatch(Actions.HomePageAction(res.data?.data?.attributes));
    });
  };

  useEffect(() => {
    if (!Object.keys(HomeData).length) getHomePageData();

    window.scrollTo({
      top: 0,
      left: 1,
      behavior: "smooth",
    });
  }, []);

  return (
    <Suspense fallback={<Loader />}>
      {!Object.keys(HomeData)?.length ? (
        <Loader />
      ) : (
        <>
          <HomeIntro HomepageTitleContent={HomeData?.HomepageTitleContent} />
          <InnovativeSlider
            HomeWhoWeAre={HomeData?.HomeWhoWeAre}
            imagesSection={HomeData?.imagesSection}
          />
          <div className=" pt-14 px-5 md:px-10 lg:px-20  md:h-auto text-black-75  flex flex-col justify-evenly  items-center max-w-screen-2xl mx-auto ">
            <div
              data-aos="fade-up"
              data-aos-delay="250"
              className="    font-custom font-semibold flex flex-col justify-center  text-[44px]"
            >
              <div className=" text-2xl sm:text-3xl md:text-4xl xl:text-5xl leading-10 tracking-[-0.017em] font-custom font-bold text-black-75 mb-3  text-center ">
                {HomeData?.HomeIntroContent?.HomeIntroContentTitle?.split(
                  "#"
                )?.map((word: string, i: number) => {
                  return i === 0 ? (
                    word + " "
                  ) : (
                    <span className=" inline-block relative after:absolute z-[100] after:-z-10  after:top-1/2 after:left-0 after:w-full after:h-3/4 after:content-[''] after:bg-[#f7941e]">
                      {word}
                    </span>
                  );
                })}
              </div>
              <section className="w-full relative grid place-content-center place-items-center mt-20 ">
                {HomeData?.HomeIntroContent?.HomeIntroCard?.map(
                  (card: Record<string, any>, i: number) => {
                    return (
                      <div
                        key={card?.Title}
                        className={`${
                          card?.Title?.trim()?.toLowerCase() === "blue mesh"
                            ? "bg-[#F5F5F5]"
                            : "bg-[#FEF2E4]"
                        } md:grid-cols-2 grid relative place-content-center z-30 first:mt-0 my-10 md:my-20 p-5 md:p-7 lg:p-10 xl:p-24 rounded-3xl`}
                      >
                        {/* Background overlay for opacity */}
                        <div
                          style={{
                            backgroundImage:
                              i === 0 ? `url(${bluemesh})` : `url(${ncs})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            borderRadius: "1.5rem",
                            opacity: 0.3, // adjust opacity here
                            zIndex: 0,
                          }}
                        />

                        {/* SVGs */}
                        <svg
                          className="hidden lg:block lg:absolute top-[5%] rotate-12 left-[4%] -z-10 opacity-0 lg:opacity-100"
                          width="380"
                          height="375"
                          viewBox="0 0 380 375"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M333.804 3.78118C360.805 -2.45681 384.434 22.8746 376.335 49.3776L285.354 347.121C277.255 373.624 243.503 381.422 224.6 361.157L12.2375 133.492C-6.66555 113.227 3.45763 80.0985 30.4593 73.8605L333.804 3.78118Z"
                            stroke="#5F5F5F"
                            strokeOpacity="0.2"
                            strokeWidth="4"
                          />
                        </svg>

                        <svg
                          className="hidden lg:block lg:absolute top-[5%] rotate-45 right-[20%] -z-10 opacity-0 lg:opacity-100"
                          width="380"
                          height="375"
                          viewBox="0 0 380 375"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M333.804 3.78118C360.805 -2.45681 384.434 22.8746 376.335 49.3776L285.354 347.121C277.255 373.624 243.503 381.422 224.6 361.157L12.2375 133.492C-6.66555 113.227 3.45763 80.0985 30.4593 73.8605L333.804 3.78118Z"
                            stroke="#5F5F5F"
                            strokeOpacity="0.2"
                            strokeWidth="4"
                          />
                        </svg>

                        {/* Image */}
                        <img
                          className={`${i === 0 ? "" : "md:order-4"}`}
                          src={`${env}${card?.Image?.data?.attributes?.url}`}
                          alt={card?.Title}
                        />

                        {/* Content */}
                        <div className="mt-3 z-[50] flex flex-col justify-center font-normal pt-3">
                          <img
                            className="max-w-[6rem] md:max-w-[12.5rem] h-auto"
                            src={`${card?.attributes?.logo}`}
                            alt={card?.Description}
                          />
                          {card?.Title?.trim()?.toLowerCase() !==
                            "blue mesh" && (
                            <p className="text-black-75 font-bold mt-2 text-xl md:text-2xl lg:text-3xl">
                              {card?.Title}
                            </p>
                          )}
                          <p className="text-base lg:text-lg font-medium font-custom leading-[21.79px] mt-3">
                            {card?.Description}
                          </p>
                          <InverseButton
                            theme={card?.attributes?.theme}
                            title={card?.attributes?.buttonText}
                            url={card?.attributes?.url}
                          />
                        </div>
                      </div>
                    );
                  }
                )}
              </section>
              {/* <div className=" font-normal lg:text-lg md:text-base text-sm py-3 ">
                {"HomeWhoWeAre?.TitleContent?.Description"}
              </div> */}
            </div>
          </div>
          <ServicesHome HomeServices={HomeData?.HomeServices} />
          <HomePageExpertiseDomainSection
            ExpertiseDomain={HomeData?.ExpertiseDomain}
          />
          <Brouchure HomeBrochure={HomeData?.HomeBrochure} />
          <History HomeHistorySection={HomeData?.HomeHistorySection} />
          <Countries HomeCountries={HomeData?.HomeCountries} />
          <AgroTechConnectSection
            AgrotechConnectSection={HomeData?.Contactus}
            widthProp="lg:w-[50%]"
          />
          <Footer />
        </>
      )}
    </Suspense>
  );
}

export default Home;

function InverseButton({
  theme,
  title,
  url,
}: {
  theme: string;
  title: string;
  url: string;
}) {
  const baseClasses =
    "mt-5 w-max border text-base md:text-base rounded-[50px] px-4 py-2 font-custom transition-colors inline-block active:scale-95 active:shadow-inner";

  const themeClasses =
    theme === "light"
      ? "bg-[#FFFFFF] text-[#616161] border-white hover:bg-[#616161] hover:text-white active:bg-[#e0e0e0] active:text-[#333333]"
      : "bg-[#616161] text-white border-[#616161] hover:bg-[#FFFFFF] hover:text-[#616161] active:bg-[#4d4d4d] active:text-[#eaeaea]";

  const isExternal = url.startsWith("http");

  if (isExternal) {
    return (
      <a
        data-aos="flip-up"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={`${baseClasses} ${themeClasses}`}
      >
        {title}
      </a>
    );
  }

  return (
    <Link
      data-aos="flip-up"
      to={url}
      className={`${baseClasses} ${themeClasses}`}
    >
      {title}
    </Link>
  );
}
